export const read_notification = `mutation read_notification($input: Int!){
    read_notification(input: $input)
}`;
